import React from "react";
import { Divider } from "antd";
import Card from "components/card";
import { 
  CircleCheck,
  Clock,
  MapPin, 
} from "lucide-react";
import { formatDateRange } from "utils/index";


const LeaveCard = ({
  employee_initials,
  employee_name,
  country,
  lve_type_name,
  date_from,
  date_to,
  lve_duration,
  status_name
}) => {

  return (
    <Card className="p-4 rounded-2xl border-2 bg-white hover:border-blue-200 hover:shadow-md transition-all duration-200 space-y-3 overflow-hidden dark:bg-white/10">
      <div className="flex items-start justify-between gap-2 overflow-hidden">
        <div className="flex items-center gap-3 min-w-0 flex-1 overflow-hidden">
          <span className="flex w-10 h-10 items-center justify-center rounded-full bg-slate-100 text-sm font-semibold dark:bg-slate-700 dark:text-white">
              {employee_initials}
          </span>
          <div className="min-w-0 flex-1 overflow-hidden">
            <p className="text-[14px] font-semibold truncate dark:text-white">{employee_name}</p>
            <div className="flex items-center gap-1.5 mt-0.5 min-w-0 overflow-hidden">
              <MapPin className="w-3 h-3 text-slate-700 flex-shrink-0  dark:text-slate-100" />
              <span className="text-[11px] text-slate-700 truncate  dark:text-slate-100">{country}</span>
            </div>
          </div>
        </div>
        <span
          className={`flex items-center text-xs border status-indicator ${lve_type_name?.toLowerCase().replace(/\s+/g, "-")}`}
        >
          {lve_type_name}
        </span>
      </div>

      <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />


      <div className="grid grid-cols-2 gap-3">
        <div className="p-2 rounded-lg bg-slate-50 border min-w-0 dark:bg-white/20">
          <span className="text-[10px] text-slate-700 font-semibold uppercase tracking-wide dark:text-slate-100">FROM</span>
          <p className="text-[12px] font-semibold mt-0.5 truncate dark:text-white">{formatDateRange(date_from)}</p>
        </div>
        <div className="p-2 rounded-lg bg-slate-50 border min-w-0 dark:bg-white/20">
          <span className="text-[10px] text-slate-700 font-semibold uppercase tracking-wide dark:text-slate-100">TO</span>
          <p className="text-[12px] font-semibold mt-0.5 truncate dark:text-white">{formatDateRange(date_to)}</p>
        </div>
      </div>

      <div className="flex items-center justify-between pt-1">
        <div className="flex items-center gap-2 text-[12px] text-slate-700 dark:text-slate-100">
          <Clock className=" w-3.5 h-3.5 flex-shrink-0" />
          <span className="font-medium">
            {lve_duration} day{lve_duration > 1 ? "s" : ""}
          </span>
        </div>

        <span
          className="status-indicator completed"
        >
          <div className="flex items-center text-xs gap-1">
            <CircleCheck className="w-3 h-3"/>
            {status_name}
          </div>
        </span>
      </div>
    </Card>

  );
};

export default LeaveCard;

